export interface ModuleSubNavItem {
  id: string;
  label: string;
  /** The section's own URL, e.g. `/people/life-events`. */
  href: string;
  /**
   * Other path prefixes that belong to this section, e.g. a collection's records
   * (`/people/` for Everyone, so `/people/123` keeps it active). A trailing slash matches
   * descendants only, never the prefix itself.
   */
  match?: string[];
}

/**
 * Whether `prefix` covers `pathname`. A plain prefix (`/people`) covers itself and anything
 * under it. A trailing slash (`/people/`) means descendants only: it's how an item claims a
 * collection's records without claiming the module root, which may be another item (Overview).
 */
function underPath(pathname: string, prefix: string): boolean {
  // The app root would otherwise cover every path, so it only matches itself.
  if (prefix === "/") return pathname === "/";
  if (prefix.endsWith("/")) return pathname.startsWith(prefix) && pathname.length > prefix.length;
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/**
 * The section that owns `pathname`: the item with the longest matching prefix, so a nested
 * section (`/people/life-events`) wins over its parent (`/people`).
 */
export function activeSubNavItemId(items: ModuleSubNavItem[], pathname: string): string | null {
  let best: { id: string; length: number } | null = null;
  for (const item of items) {
    for (const prefix of [item.href.split("?")[0], ...(item.match ?? [])]) {
      if (underPath(pathname, prefix) && (!best || prefix.length > best.length)) {
        best = { id: item.id, length: prefix.length };
      }
    }
  }
  return best?.id ?? null;
}
